import Vue from 'vue';
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm';
import moment from 'vue-moment';
import App from './App.vue';
import router from './router';
import 'bootstrap-vue/dist/bootstrap-vue.css';
import 'bootstrap/dist/js/bootstrap';
import Vuelidate from 'vuelidate';
import store from './store/auth-store';
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';
import GoogleAuth from 'vue-google-authenticator';
import Vue2Editor from 'vue2-editor';
import vSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import VueBootstrapTypeahead from 'vue-bootstrap-typeahead';
import VuePhoneNumberInput from 'vue-phone-number-input';
import 'vue-phone-number-input/dist/vue-phone-number-input.css';
import vueDebounce from 'vue-debounce';
import VueClipboard from 'vue-clipboard2';

import '../src/assets/style/css/vue-material/default.css';
import '../src/assets/style/css/vue-material/vue-material.css';
import VueMaterial from 'vue-material';
import VueCookies from 'vue-cookies';

Vue.use(VueCookies);
Vue.use(VueMaterial);
Vue.use(GoogleAuth, {client_id: '174343362600-jvf4p9vqkqk3jl9pha7l081ilqb6i6e0.apps.googleusercontent.com'});
Vue.component('vue-phone-number-input', VuePhoneNumberInput);
Vue.googleAuth().load();

Vue.use(BootstrapVue);
Vue.use(moment);
Vue.use(Vuelidate);
Vue.use(VueSweetalert2);
Vue.use(Vue2Editor);
Vue.use(VueClipboard);
Vue.component('v-select', vSelect);
Vue.component('vue-bootstrap-typeahead', VueBootstrapTypeahead);

Vue.config.productionTip = false;
Vue.use(vueDebounce);
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app');
